import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { IApp } from '../../shared/models/app.interface';
import { Globals } from '../../shared/utils/globals';
import { CommonService } from 'src/app/shared/services/common.service';
import { SecurityService } from '../security/security.service';
import { SecurityFindingComment } from 'src/app/shared/models/security-finding-comment.model';
import { AppTabElement } from '../shared/app-tabs/app-tab-element.interface';
import { GetLiveSecurityFindingsResponseDto } from './open-production-findings/models/getLiveSecurityFindingsResponseDto';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.scss'],
})
export class SecurityComponent implements OnInit {
  selectedApp: IApp;
  loading: boolean = false;
  tblData: SecurityFindingComment[];
  tblCols: string[];
  eventsSubject: Subject<void> = new Subject<void>();
  appTabElements: AppTabElement[];
  currentSelectedTab = 0;
  liveSecurityFindingsResponse: GetLiveSecurityFindingsResponseDto;

  constructor(
    public service: SecurityService,
    public globals: Globals,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.getFindingsComments();
    this.initializeAppTabElements();
    this.getLiveSecurityFindings();
  }

  getFindingsComments() {
    this.loading = true;
    this.service.getFindingsComments().subscribe({
      next: (response) => {
        this.loading = false;
        this.tblData = response.pending_comments;
      },
    });
  }

  initializeAppTabElements() {
    const tabElements = this.translateService.instant(
      'component.security.tabs',
    );

    this.appTabElements = Object.entries(tabElements).map(
      ([key, value]) =>
        ({ label: value, value: Number.parseInt(key) } as AppTabElement),
    );
  }

  getLiveSecurityFindings() {
    this.loading = true;
    this.service
      .getLiveSecurityFindings()
      .subscribe((res) => (this.liveSecurityFindingsResponse = res))
      .add(() => (this.loading = false));
  }
}
